import React from "react"
import class_names from "classnames"
import MediaIcon from "components/media_icon"

const Contentbox = ({
  class_name,
  title,
  highlighted_title,
  url,
  description,
  image_url,
  published_at,
  on_click,
  type
}) => {
  if (!highlighted_title) highlighted_title = title
  return (
    <div className={class_names("contentbox", class_name)} onClick={on_click}>
      <div className="contentbox-image spinner">
        <a href={url} title={title}>
          <img src={image_url} alt={title} crossOrigin="anonymous" key={url} />
        </a>
      </div>
      <a href={url} title={title} className="contentbox-topic">
        {published_at && published_at > three_weeks_ago() ? (
          <div className={`contentbox__new_${window.gon.locale}`} />
        ) : undefined}
        <div className="contentbox-title">
          {type && <MediaIcon name={type}/>}
          {type && " "}
          {highlighted_title}
        </div>
        {description ? (
          <div className="contentbox-description">{description}</div>
        ) : undefined}
      </a>
    </div>
  )
}

const three_weeks_ago = () =>
  // the time we create in ruby for Algolia doesn't contain the miliseconds
  Math.floor((new Date().getTime() - 3 * 7 * 24 * 60 * 60 * 1000) / 1000)

export default Contentbox
